import getApi from '../../api'
import { MailList } from '../../model/Mail'

export const getMailList = (offset: number, limit: number, signal?: AbortSignal, search?: string) =>
  getApi().get<MailList>(`/mss/messages`, { offset, limit, search }, { signal })
